import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useLang } from '../contexts/LangContext';

const AFII_LOGO = "https://customer-assets.emergentagent.com/job_afii-future/artifacts/zz1rxbi3_image.png";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#050B14] border-t border-white/10 px-6 md:px-12 lg:px-24 py-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={AFII_LOGO} alt="AFII" className="w-10 h-10 rounded-lg object-contain" />
            <div>
              <p className="font-['Outfit'] font-bold text-white text-sm">{t('footer.africanFuture')}</p>
              <p className="font-['Manrope'] text-white/40 text-xs">{t('footer.celestialMinds')}</p>
            </div>
          </div>

          <div className="flex items-center gap-6">
            <Link to="/courses" className="font-['Manrope'] text-white/40 text-xs hover:text-white/70 transition-colors duration-200">Courses</Link>
            <Link to="/mentor-waitlist" className="font-['Manrope'] text-white/40 text-xs hover:text-white/70 transition-colors duration-200">Mentors</Link>
            <Link to="/chat" className="font-['Manrope'] text-white/40 text-xs hover:text-white/70 transition-colors duration-200">Chat with Grace</Link>
            <Link to="/contact" className="font-['Manrope'] text-white/40 text-xs hover:text-white/70 transition-colors duration-200">Contact Us</Link>
            <a href="https://www.paypal.com/ncp/payment/5DFPE4AJG9DJ4" target="_blank" rel="noopener noreferrer" className="font-['Manrope'] text-[#D4A843] text-xs hover:text-[#F5D78E] transition-colors duration-200 font-medium">Donate</a>
          </div>

          <div className="flex items-center gap-1.5 text-white/25 text-xs font-['Manrope']">
            <Globe className="w-3 h-3" />
            <span>{t('footer.empowering')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
